import { Stack, Typography } from "@mui/material";
import {
  Person,
  prettyTitle,
  readableRelationship,
  NotifierRolesToUI,
  NotifierRoles,
  NotifierRolesByServer,
} from "@/types";
import { formatDate } from "@/utils/Functions";
import React from "react";
import { FieldsTableHeader, FieldsTable, FieldRow } from "../molecules";
import { colors } from "@/styles/constants";

interface PersonSummaryI {
  person: Person;
  onEdit: () => void;
}
export const PersonSummary: React.FC<PersonSummaryI> = ({ person, onEdit }) => {
  if (!person) {
    return (
      <Stack rowGap={2}>
        <FieldsTableHeader title="Your details" onEdit={onEdit} />
        <Typography variant="body1" color={colors.fadedText}>
          Not completed yet
        </Typography>
      </Stack>
    );
  }

  let role = "";
  if (
    !person.roles ||
    person.roles.length === 0 ||
    person.roles.includes(NotifierRolesByServer.Notifier)
  ) {
    role = "Your ";
  } else if (person.roles.includes(NotifierRolesByServer.Nok)) {
    role = "Next Of Kin ";
  } else if (person.roles.includes(NotifierRolesByServer.Executor)) {
    role = "Executor ";
  } else {
    console.log("unknown type for person.roles");
  }
  const title = `${role} Details`;

  return (
    <FieldsTable header={<FieldsTableHeader title={title} onEdit={onEdit} />}>
      <FieldRow
        label="Name"
        value={`${prettyTitle(person?.title)} ${person.firstName} ${person.lastName} `}
      />
      <FieldRow
        label="Date of birth"
        value={person.dateOfBirth ? formatDate(person?.dateOfBirth) : ""}
      />
      <FieldRow
        label="Address"
        value={
          <>
            {person?.address}
            <br />
            {person?.city}
            <br />
            {person?.postcode}
          </>
        }
      />
      <FieldRow label="Phone" value={person.contactNumber ?? ""} />
      <FieldRow label="Email" value={person.email ?? ""} />
      <FieldRow label="Vulnerable?" value={person.isVulnerable ? "Yes" : "No"} />
      <FieldRow
        label="The person who died was"
        value={readableRelationship(person.relationshipToDeceased) ?? ""}
      />
      {!person.roles && (
        <FieldRow label="Role" value={NotifierRolesToUI[person.role as NotifierRoles] ?? ""} />
      )}
    </FieldsTable>
  );
};
